import { Transformations, enhanceImageUrl } from 'utils';
import { Banner } from './model-json-types';

/**
 * Добавляет к урлу изображения модификаторы
 * @param {Banner[]} bannerList
 * @param {Transformations} transformations
 * @returns {Banner[]}
 */
export const modifyBannerImages = (bannerList: Banner[], transformations?: Transformations) =>
  bannerList.map(({ image, ...rest }) => ({
    ...rest,
    image: enhanceImageUrl(image, transformations),
  }));

const DATE_REGEXP = /(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0,1,2])\.(19|20)\d{2} ([01][0-9]|2[0-3]):([0-5][0-9])/;

export const checkIfDateRangeActual = (startDate: string, endDate: string) => {
  const localDate = new Date();

  if (!startDate.match(DATE_REGEXP) || !endDate.match(DATE_REGEXP)) {
    return false;
  }

  const startDateSplit = startDate.split(' ');
  const endDateSplit = endDate.split(' ');

  const date = new Date(localDate.getTime()).toISOString();
  const startDateISO = new Date(
    `${startDateSplit[0].split('.').reverse().join('-')} ${startDateSplit[1]}`
  ).toISOString();
  const endDateISO = new Date(
    `${endDateSplit[0].split('.').reverse().join('-')} ${endDateSplit[1]}`
  ).toISOString();

  return date >= startDateISO && date <= endDateISO;
}
